import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = window.localStorage.getItem('tm_admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export function setAdminToken(token) {
  if (token) window.localStorage.setItem('tm_admin_token', token);
  else window.localStorage.removeItem('tm_admin_token');
}

export function getAdminToken() {
  return window.localStorage.getItem('tm_admin_token');
}
